import SubmitButton from './SubmitButton';
export type { SubmitButtonProps } from './SubmitButton.types';

export default SubmitButton;
